module.exports = {
    title: __CONTACT_CENTER__ ? 'contractsView-contractsView_depositBonifiedWithoutNewBalanceTitleCC' : 'contractsView-contractsView_depositBonifiedWithoutNewBalanceTitle',
    order: 1,
    footer_text: '',
    position: 'first',
    components: [
        ...(
            __CONTACT_CENTER__ ?
            [{
                id_component: 'contract-info',
                id: 'text-info',
                cms_key: 'depositbonifiedwonm_cc',
            }] : [{
                id_component: 'contract-info',
                id: 'text-info',
                cms_key: 'depositbonifiedwonm',
            }]
        )
    ]
};
